import {
  _AdvanceLeaseActionType,
  _CancelLeaseActionType,
  CancelLeasePayload,
} from "~/types/lease";
import { editApplication } from "./editApplication";
import { editBackgroundCheck } from "./editBackgroundCheck";
import { editLease } from "./editLease";
import { editMoveExam } from "./editMoveExam";
import { editOffer } from "./editOffer";
import * as APITypes from "~/API";

export const cancelLease = async (payload: CancelLeasePayload) => {
  const date = new Date();
  switch (payload.cancelAction) {
    case "_Deny_Application": {
      const deny = await editApplication({
        id: payload.applicationID,
        status: APITypes.ApplicationStatusType.Rejected,
        endDate: date.toUTCString(),
        _version: payload.applicationVersion,
      });

      const result = await editLease({
        id: payload.leaseID,
        status: APITypes.LeaseStatusType.Rejected,
        endDate: date.toUTCString(),
        _version: payload.leaseVersion,
      });
      return result;
    }
    case "_Deny_Background": {
      const deny = await editBackgroundCheck({
        id: payload.backgroundCheckID,
        status: APITypes.BackgroundCheckStatusType.Rejected,
        endDate: date.toUTCString(),
        _version: payload.backgroundCheckVersion,
      });

      const result = await editLease({
        id: payload.leaseID,
        status: APITypes.LeaseStatusType.Rejected,
        endDate: date.toUTCString(),
        _version: payload.leaseVersion,
      });
      return result;
    }
    case "_Cancel_Offer": {
      const result = await editOffer({
        id: payload.offerID,
        status: APITypes.OfferStatusType.Canceled,
        endDate: date.toUTCString(),
        _version: payload.offerVersion,
      });

      const lease = await editLease({
        id: payload.leaseID,
        status: APITypes.LeaseStatusType.Rejected,
        endDate: date.toUTCString(),
      });

      return result;
    }
    case "_Cancel_MoveIn": {
      const result = await editMoveExam({
        id: payload.moveInID,
        status: APITypes.MoveExamStatusType.Failed,
        endDate: date.toUTCString(),
        _version: payload.moveInVersion,
      });

      // const terminate = await unsetActiveLease({
      //   leaseID: payload.leaseID,
      //   unitID: payload.entityID,
      //   status: APITypes.LeaseStatusType.Rejected,
      //   force: false,
      // });
      return result;
    }
    case "_Cancel_MoveOut": {
      const result = await editMoveExam({
        id: payload.moveOutID,
        status: APITypes.MoveExamStatusType.Failed,
        endDate: date.toUTCString(),
        _version: payload.moveOutVersion,
      });
      return result;
    }
  }
};
